import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Search, Go, Question, Menu } from '../../common/icons';
import { getProducts } from '../../../actions/products-list';

class SearchBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: '',
      data: [],
      otherProducts: 0
    };
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    }, () => {
      this.handleFilter();
    });
  }

  handleFilter = () => {
    const { products } = this.props;
    const { search } = this.state;

    if (search) {
      let data = products.filter(product => (
        product.attributes.brand.name.toLowerCase().includes(search.toLowerCase()) ||
        product.attributes.category.name.toLowerCase().includes(search.toLowerCase()) ||
        product.attributes.name.toLowerCase().includes(search.toLowerCase())
      ));

      if (data.length > 5) {
        this.setState({
          otherProducts: data.length - 5
        });

        data = data.slice(0, 5);
      } else {
        this.setState({
          otherProducts: 0
        });
      }

      this.setState({
        data
      });
    } else {
      this.setState({
        data: [],
        otherProducts: 0
      });
    }
  }

  componentDidMount = () => {
    const { dispatch, products } = this.props;

    if (products.length === 0) {
      dispatch(getProducts());
    }
  }

  render = () => {
    const { hasGoldTheme } = this.props;
    const {
      search, data, otherProducts
    } = this.state;
    const inputClassName = hasGoldTheme ? 'form-control-gold' : '';
    const searchIconClassName = hasGoldTheme ? 'navbar-search-icon navbar-search-icon-gold' : 'navbar-search-icon';

    return (
      <div className="navbar-search-container">
        <input
          type='text'
          name='search'
          value={search}
          placeholder='Search for a category, brand or product'
          className={inputClassName}
          onChange={e => this.handleInputChange(e)}
        />
        <Search height={24} width={24} className={searchIconClassName} />
        {data.length > 0 && (
          <div className="navbar-search-filtered-container">
            {data.map(product => (
              <a href={`/brands?brand=${product.attributes.brand.name}`} className="product-data-container" key={product.id}>
                <div className="product-data-inner">
                  <div className="product-data-image-container">
                    <img src={product.attributes.links.image} alt={product.attributes.name} className="product-data-image" />
                  </div>
                  <h5 className="product-data-name">{product.attributes.name}</h5>
                </div>
                <div className="go-container">
                  <Go height={24} width={24} />
                </div>
              </a>
            ))}
            {otherProducts > 0 && (
              <a href={'/products'} className="other-products">
                {otherProducts} other products available.<br />
                Please click to view full list of products available
              </a>
            )}
          </div>
        )}
        {data.length === 0 && search.length > 0 && (
          <div className="navbar-search-filtered-container">
            <div className="product-no-data-container">
              <div className="question-container">
                <Question height={24} width={24} />
              </div>
              <h5 className="product-no-data-info">
                <span className="sorry-highlight">Sorry!</span> Currently you can only search for a category,
                brand or product. Please try the <Menu className="menu-icon" height={12} width={12} />
                icon to find what you are looking for.
              </h5>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  products: state.userProductsList.products,
  hasGoldTheme: state.deep.my_profile.has_ignite_gold_outlet,
  myProfile: state
});

export default connect(mapStateToProps)(SearchBar);



// WEBPACK FOOTER //
// ./src/components/layout/user-navigation/navbar-searchbar.jsx